<h3 class="text-center text-light bg-secondary border">{{loadStatus}} ({{filteredLoads.length}})</h3>
<!--
    Pageable grid
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [pageable]="{ pageSizes: pageSizes }"

    Full size grid
    [pageable]="false"

    (selectionChange)="rowSelected($event)"
 -->
<kendo-grid #loadsGrid
            [data]="gridData"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageable]="bulkTenderLoads.length==0"
            [sortable]="bulkTenderLoads.length==0"
            [filterable]="bulkTenderLoads.length==0"
            [resizable]="bulkTenderLoads.length==0"
            [autoSize]="true"
            [selectable]="bulkTenderLoads.length==0"
            [rowClass]="rowCallback"
            class="hideFilterOperators"
            (selectionChange)="rowSelected($event)"
            (dataStateChange)="dataStateChange($event)"
            (filterChange)="filterChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
            <button class="btn btn-secondary m-1" (click)="sendAvailableLoadOfferEmail(load)" *ngIf="isShowBulkTender!=true">Email Offer</button>
            <a [routerLink]="" (click)="rowSelected(load)" *ngIf="isShowBulkTender!=true">
                <i class="fas fa-angle-double-right fa-lg ml-3"
                   [ngClass]="{'text text-primary': load.quoteOrderLineID==selectedLoad.quoteOrderLineID}"></i>
            </a>
            <input type="checkbox" (click)="toggleBulkTender(load)" [(ngModel)]="load.isBulkTender"
                   style="cursor:pointer;margin:5px 20px;transform: scale(1.5);"
                   *ngIf="isShowBulkTender==true" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority" [hidden]="viewType=='rfq'">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType=='orders'" field="quoteOrderLineID" title="Quote #">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trailer" title="Trailer">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='rfq'" field="loadType" title="Type">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mode" title="Mode">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            {{load.rateIndex}}
            <a target="_self" [routerLink]="" title="Cannot Cover - Set to Spot and email Account Manager" tabindex="-1" (click)="setQuoteOrderLineRateIndex(load, 'Spot')" *ngIf="load.rateIndex=='Contract'&&load.loadStatus=='Available'"><i class="fas fa-exclamation-triangle text-warning"></i></a>
            <!--<a target="_self" [routerLink]="" title="Cannot Cover - Set to Planned" tabindex="-1" (click)="setQuoteOrderLineLoadStatus(load, 'Planned')" *ngIf="load.rateIndex=='Contract'&&load.loadStatus=='Available'"><i class="fas fa-lock text-secondary"></i></a>-->
            <!--<button class="btn btn-sml btn-secondary m-2" title="Set to Available" tabindex="-1" *ngIf="load.loadStatus=='Planned'" (click)="setQuoteOrderLineLoadStatus(load, 'Available')"><i class="fas fa-lock-open"></i></button>-->
            <!--<button class="btn btn-sml btn-secondary m-2" title="Set to Planned" tabindex="-1" *ngIf="load.loadStatus=='Available'" (click)="setQuoteOrderLineLoadStatus(load, 'Planned')"><i class="fas fa-lock"></i></button>-->
            <!--<button class="btn btn-sml btn-danger m-2" title="Cancel Load" tabindex="-1" *ngIf="load.loadStatus!='Canceled'&&load.loadStatus!='Completed'" (click)="setQuoteOrderLineLoadStatus(load, 'Canceled')"><i class="fas fa-ban"></i></button>-->
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="originState" title="O-State">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-State">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="isRoundTrip" title="RT">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isRoundTrip!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isRoundTrip==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="earliestDate" title="Earliest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="latstDate" title="Latest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.latestDate == '' ? '' : load.latestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="arrivalStartDate" title="{{viewType == 'rfq' ? 'Due' : 'Start'}}">
        <ng-template kendoGridCellTemplate let-load>
            {{load.arrivalStartDate == '' ? '' : load.arrivalStartDate | date: 'M/dd'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='orders'" field="convoyStatus" title="Convoy">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="offers" title="HC" [hidden]="viewType!='rfq'"></kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='orders'" field="loadType" title="Type">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="targetCost" title="Target">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngIf="!isCSRManager">{{load.targetCost == null ? '' : load.targetCost | currency}}</span>
            <span *ngIf="isCSRManager"><input type="text" [(ngModel)]="load.targetCost" (change)="updateLoad(load.quoteOrderLineID,load,$event)" /></span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="maxCarrierPay" title="Max Pay">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngIf="!isCSRManager">{{load.maxCarrierPay == null ? '' : load.maxCarrierPay | currency}}</span>
            <span *ngIf="isCSRManager"><input type="text" [(ngModel)]="load.maxCarrierPay" (change)="updateLoad(load.quoteOrderLineID,load,$event)" /></span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType=='orders'" field="finalCost" title="Final Cost">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngIf="!isCSRManager || viewType != 'quotes'">{{load.finalCost == null ? '' : load.finalCost | currency}}</span>
            <span *ngIf="isCSRManager && viewType == 'quotes'"><input type="text" [(ngModel)]="load.finalCost" (change)="updateLoad(load.quoteOrderLineID,load,$event)" /></span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [hidden]="viewType!='rfq'&&viewType!='quotes'&&viewType!='open-dedicated'" field="frequency" title="Frequency">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assignedToName" title="Assigned">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            <a [routerLink]="" (click)="editCarrierReps(load)" *showRolesIf="'Carrier Sales Manager'"><i class="fas fa-pen-square fa-2x text-success"></i></a>
            {{load.assignedToName}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="accountManagerName" title="Acct Mgr">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="repsAssigned" title="Reps">
    </kendo-grid-column>
    <kendo-grid-column field="offers" title="HC" [hidden]="viewType=='rfq'">
    </kendo-grid-column>
    <kendo-grid-column field="minutesSinceLastOffer" title="Last Call">
    </kendo-grid-column>
    <kendo-grid-column field="minBidRate" title="Min Rate" format="{0:c}">
    </kendo-grid-column>
    <kendo-grid-column title="Tags">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                <tagtype-tag [tag]="tag"></tagtype-tag>
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="billTo" title="Bill To">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/customer-detail', load.billTo]">
                {{load.billTo}} - {{load.billToName}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority" [hidden]="viewType!='rfq'">
        <ng-template kendoGridFilterCellTemplate let-column="column" let-filter="filter" let-filterService="filterService">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter"></kendo-grid-string-filter-cell>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>

<kendo-dialog *ngIf="(assignedLoad | json) != '{}'" [width]="'50%'" [height]="'75%'" (close)="cancelDialogClick()">
    <kendo-dialog-titlebar>
        <h2>Order #{{assignedLoad.quoteOrderID}}-{{assignedLoad.legNumber}}</h2>
    </kendo-dialog-titlebar>
    <carrier-rep-assigned [quoteOrderLineID]="assignedLoad.quoteOrderLineID"></carrier-rep-assigned>
    <kendo-dialog-actions>
        <button (click)="cancelDialogClick()" class="btn btn-secondary m-2" mat-button>
            Close
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
